import * as Lang$SolvuuApi0 from "solvuu-api0/./lang.bs.js";
var Label = Lang$SolvuuApi0.Label;
var Var = Lang$SolvuuApi0.Var;
var Type = Lang$SolvuuApi0.Type;
var Term = Lang$SolvuuApi0.Term;
var Record = Lang$SolvuuApi0.Record;
var Table = Lang$SolvuuApi0.Table;
export { Label, Var, Type, Term, Record, Table };
/* Lang-SolvuuApi0 Not a pure module */